<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-06-19 13:35:36
 * @LastEditTime : 2025-06-19 14:08:01
 * @LastEditors  : yangxr
 * @Description  : 明细供应商
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\accountingSheet\report\supplierTable.vue
-->
<template>
    <div>
        <el-dialog :visible.sync="dialog" width="1000px" :close-on-click-modal="false" >
          <span slot="title" class="dialog-title">明细供应商</span>
          <div class="dialoginfo">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="centerRow.amountShares" tooltip-effect="dark" highlight-current-row @current-change="handleCurrentChange" @row-dblclick="rowDblclick">
                <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
                <template v-for="(item, index) in centerRow.dataType == 3 ? tableB : tableA">
                    <el-table-column v-if="item" :key="index"  :prop="item.prop" :label="item.label" :width="item.width" align="center" 
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="item.label == '序号'"> {{ scope.$index + 1 }} </span>
                            <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
          </div>
          <span slot="footer" class="dialog-footer"> 
            <el-button class="bottom_all_two" @click="reset">取 消</el-button>
            <el-button class="bottom_all" @click="submitDept" >确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    components: {
    },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        centerRow:[]
    },
    data(){
        return {
            tableParams:{
                page:1,
                pageSize:10,
                code:"",
                name:"",
                status:1,//只查询启用状态
            },
            accessToken:"",
            total:0,
            accountTableData:[],
            tableA: [
                { label: "供应商", prop: "supplyName", status: true, width: "auto" },
                { label: "明细供应商", prop: "detailSupplyName", status: true, width: "auto" },
                { label: "期初", prop: "initAmount", status: true, width: "100" },
                { label: "入库", prop: "inAmount", status: true, width: "100" },
                { label: "理论耗用", prop: "theoryAmount", status: true, width: "100" },
                { label: "实际耗用", prop: "actualOutAmount", status: true, width: "100" },
                { label: "期末(期末+入库-耗用)", prop: "endAmount", status: true, width: "150" },
            ],
            tableB: [
                { label: "供应商", prop: "supplyName", status: true, width: "auto" },
                { label: "明细供应商", prop: "detailSupplyName", status: true, width: "auto" },
                { label: "期初", prop: "initAmount", status: true, width: "100" },
                { label: "入库", prop: "inAmount", status: true, width: "100" },
                { label: "耗用", prop: "actualOutAmount", status: true, width: "100" },
                { label: "期末(期末+入库-耗用)", prop: "endAmount", status: true, width: "150" },
            ],
            currentRow:{},
            form:{},
            ncNo:"",
            userName:"",
        }
    },
    watch:{
      centerRow(val){
        console.log(val)
      },
    },
    methods:{
      rowDblclick(row){
        this.currentRow = row;
        this.submitDept()
      },
        initData(){
        },
        setNcNo(data){
          this.ncNo = data.code
          this.userName = data.name
        },
        restParams(){
           this.tableParams={
                page:1,
                pageSize:10,
                code:"",
                name:"",
            }
            this.initData();
        },
        submitDept(){
            if(this.currentRow.length==0){
              this.$message.warning("请选中一条数据");
              return;
            }
            this.$emit("setDetail",this.currentRow)
            this.reset()
        },
        handleCurrentChange(val){
            this.currentRow = val;
        },
        reset() {
          this.$emit("reset");
        },
        sizeChange(value) {
            this.tableParams.pageSize = value;
            this.initData();
        },
    }
}
</script>
<style lang="scss" scoped>
.addClass{
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}
.mr15{
  margin-right: 15px;
}
::v-deep .el-table__body tr.current-row > td {
    color: #fff;
    background: #00b85c !important;
}
</style>